import router from '@/router';
import store from '@/store';

const rendererMixin = {
  methods: {
    findNestedObjectPropertyValue(propertyName, object) {
      return propertyName.split('.').reduce((prev, curr) => {
        // eg:- personalInfo[0].firstName (like any index routing in obbject array)
        if (curr.indexOf('[') > 0) {
          const index = curr.slice(curr.indexOf('[') + 1, curr.indexOf(']'));
          curr = curr.slice(0, curr.indexOf('['));
          prev = prev[curr][index];
        } else {
          prev = prev[curr];
        }
        if (prev !== null) {
          return prev;
        } else {
          return 'success';
        }
      }, object);
    },
    async displayPopUpContent(response, formAction, formData, entityCode) {
      let content = formAction?.previewAsIn?.content;

      content = content?.replaceAll(
        /{{(.*?)}}/g,
        ((e) => {
          const property = e.slice(e.indexOf('{') + 2, e.indexOf('}'));
          // eg: personalInfo.firstName
          if (property.split('.').length) {
            const dynamicPropertyValue = this.findNestedObjectPropertyValue(property, response.data);
            return dynamicPropertyValue;
          }
          return response.data[e.replace(/[{}]/g, '')];
        }) || '',
      );
      this.modelDataObj = this.getInitialData().modelDataObj;
      this.modalConfig = { // Resetting modal pop-up config to remove stale data
        enabled: false,
        icon: '',
        persistent: true,
        close: false,
        title: '',
        width: '',
        content: '',
        saveButton: 'OK',
        cancelButton: 'Cancel',
        customToolBar: false,
        alignCenter: true,
      };
      this.rendererModal = false;
      this.modalConfig.enabled = true;
      this.modalConfig.content = content;
      this.modalConfig.width = 610;
      this.modalConfig.close = true;
      this.modalConfig.hideToolbar = true;
      this.modalConfig.rounded = true;
      this.modalConfig.title = `${this.$t(`formStaticValue.${entityCode}.webhook.responsePreview.title`)}`;
      this.modalConfig.saveCallback = () => {
        this.submitAction(response, formAction.submitAction, formData);
      };
    },
    submitAction(data, submitAction, formData) {
      if (data && submitAction.type === 'reset') {
        Object.keys(formData).forEach((key) => (formData[key] = null));
        this.formInput = Object.assign({}, { data: { ...formData } });
      } else if (data && submitAction.type === 'redirect') {
        const defaultValueMap = store.getters['userStore/userData']?.defaultValueMap || [];

        // To store values in fromRoute before redirecting to toRoute
        if (submitAction && submitAction.redirectDynamicParams) {
          submitAction.redirectDynamicParams.forEach((param) => {
            defaultValueMap.push({
              key: param.key,
              value: formData[param.key],
            });
          });
        }
        store.dispatch('userStore/setUserData', { defaultValueMap });
        store.dispatch('userStore/setUserData', { isRedirected: submitAction.defaultPageLoad });
        router.push(`/${submitAction.redirectPath}`);
      }
    },
    async displayComponentFields(response, formAction, formData) {
      const { layout, layoutComponentDetails } = formAction?.previewAsIn;
      const formComponents = this.modelDataObj?.data?.components || this.dataObj.data.components;
      const layoutComponent = formComponents.filter((component) => component.key === layout);
      const { data, headers } = response;
      const panels = formComponents.filter((component) => component.type === 'panel');
      let totalCount;

      if (headers && headers['x-total-count']) {
        totalCount = parseInt(headers['x-total-count']);
      }
      if (layoutComponent?.length) {
        layoutComponent[0].hidden = false;
      }
      layoutComponentDetails.forEach((obj) => {
        if (panels.length) {
          panels.forEach((panel) => {
            panel.components.forEach((nestedComponent) => {
              nestedComponent.forEach((childComponent) => {
                if (childComponent.key === obj.key) {
                  Object.assign(formData, {
                    ...formData,
                    [childComponent.parentKey]: {
                      ...formData[childComponent.parentKey],
                      [obj.key]: obj.value.split('.').reduce((prev, cur) => prev[cur], data) || data,
                    },
                  }, {
                    ...({ pagination: {
                      ...formData.pagination,
                      [obj.key]: obj.value.split('.').length > 1 ? data[obj.value.split('.')[0]].headers['x-total-count'] : totalCount,
                    } }),
                  },
                  );
                }
              });
            });
          });
        }
        const dynamicPropertyValue = this.findNestedObjectPropertyValue(obj.value, data);

        Object.assign(
          formData,
          {
            ...formData,
            [obj.key]: dynamicPropertyValue || data,
          },
          {
            ...{
              pagination: {
                ...formData.pagination,
                [obj.key]:
                  obj.value.split('.').length > 1
                    ? data[obj.value.split('.')[0]]?.headers &&
                    data[obj.value.split('.')[0]]?.headers['x-total-count']
                    : totalCount,
              },
            },
          },
        );
      });
      if (this.rendererModal) {
        this.modalFormInput = Object.assign({}, this.modalFormInput, { data: { ...formData } }, {
          ...(totalCount && {
            pagination: {
              totalCount,
            },
          }),
        });
      } else {
        this.formInput = Object.assign({}, this.formInput, { data: { ...formData } });
      }
    },
    handleUserMessage(messageProperties, saveResponse = {}) {
      const { data, status } = saveResponse;
      const targetIndex = messageProperties.findIndex(
        (property) => property.messageStatusCode === status,
      );

      if (targetIndex > -1) {
        const { messageDisplayType, messageType, messageColor, messageIcon, messageInfoType, messageTitle, messageContent, messageContentKey, messageTitleKey, popUpImage } = messageProperties[targetIndex];
        let content;
        switch (messageDisplayType) {
          case 'inForm':
            this.isAlertVisibile = true;
            store.dispatch('appStore/setAppData', {
              message: {
                content: messageInfoType && messageInfoType === 'static' ? messageContent : Array.isArray(data) ? this.findNestedObjectPropertyValue(messageContentKey, { data }) : this.findNestedObjectPropertyValue(messageContentKey, data),
                type: messageType,
                component: 'alert',
                close: true,
                persistent: true,
                color: messageColor,
                icon: messageIcon,
                title: messageInfoType && messageInfoType === 'static' ? messageTitle : Array.isArray(data) ? this.findNestedObjectPropertyValue(messageTitleKey, { data }) : this.findNestedObjectPropertyValue(messageTitleKey, data),
                width: '500px',
                messageProperty: true,
              },
            });
            break;
          case 'snackbar':
            content = messageInfoType && messageInfoType === 'static' ? messageContent : Array.isArray(data) ? this.findNestedObjectPropertyValue(messageContentKey, { data }).toString() : this.findNestedObjectPropertyValue(messageContentKey, data).toString();
            if (content !== 'success') {
              store.dispatch('appStore/setAppData', {
                message: {
                  content: content,
                  type: content === 'success' ? 'success' : messageType,
                  title: messageInfoType && messageInfoType === 'static' ? messageTitle : Array.isArray(data) ? this.findNestedObjectPropertyValue(messageTitleKey, { data }) : this.findNestedObjectPropertyValue(messageTitleKey, data),
                  component: 'snackbar',
                  close: true,
                  persistent: true,
                  icon: messageIcon || '',
                  color: messageColor || '',
                  messageProperty: true,
                },
              });
            }

            break;
          case 'popUp':
            store.dispatch('appStore/setAppData', {
              message: {
                content: messageInfoType && messageInfoType === 'static' ? messageContent : Array.isArray(data) ? this.findNestedObjectPropertyValue(messageContentKey, { data }) : this.findNestedObjectPropertyValue(messageContentKey, data),
                type: messageType,
                component: popUpImage ? 'imageModal' : 'modal',
                close: true,
                persistent: true,
                icon: messageIcon || '',
                color: messageColor || '',
                title: messageInfoType && messageInfoType === 'static' ? messageTitle : Array.isArray(data) ? this.findNestedObjectPropertyValue(messageTitleKey, { data }) : this.findNestedObjectPropertyValue(messageTitleKey, data),
                messageProperty: true,
                status,
              },
            });
            break;
          default:
            console.log('Invalid message display type in handleUserMessage of rendererMixin');
            break;
        }
      }
    },
  },
};

export default rendererMixin;
